var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:({'background-color':_vm.$store.getters.getColorPalette().backgroundColorCode}),attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('TargetsTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }